import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useChat } from '../context/ChatContext';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import ChatArea from '../components/ChatArea';
import Composer from '../components/Composer';

export default function Chat() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isAuthenticated, checkAuth } = useAuth();
  const { loadBrands, loadThreads, selectedBrand } = useChat();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Check auth on mount
  useEffect(() => {
    const init = async () => {
      // If user was passed from AuthCallback, use it directly
      if (location.state?.user) {
        return;
      }
      
      // Otherwise check auth
      const authUser = await checkAuth();
      if (!authUser) {
        navigate('/login');
      }
    };
    init();
  }, [checkAuth, navigate, location.state]);

  // Load brands when authenticated
  useEffect(() => {
    if (isAuthenticated) {
      loadBrands();
    }
  }, [isAuthenticated, loadBrands]);

  // Load threads when brand is selected
  useEffect(() => {
    if (selectedBrand) {
      loadThreads(selectedBrand.brand_id);
    }
  }, [selectedBrand, loadThreads]);

  // Loading state
  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="flex h-screen w-full overflow-hidden bg-background text-foreground" data-testid="chat-page">
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      
      {/* Main area */}
      <div className="flex-1 flex flex-col h-full relative">
        <Header onMenuClick={() => setSidebarOpen(true)} />
        <ChatArea />
        <Composer />
      </div>
    </div>
  );
}
